import { Products } from "@/components/Products";
import { useSEO } from "@/lib/useSEO";

export const ProductsPage = ({ onAdd, onAuthOpen, onCartOpen }) => {
  useSEO({
    title: "Shop Pickles",
    description: "Browse our range of homemade Andhra pickles — Chicken, Mutton, Prawn, Ulli Avakaye, and Ginger pickle — available in 250g, 500g, and 1kg packs.",
  });
  return <Products onAdd={onAdd} onCartOpen={onCartOpen} />;
};
